module.exports = __webpack_public_path__ + "static/media/card_brand_elo.7922c1ff.svg";